var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "System.Preload.New",
    "options": {
        "objc_class_prefix": "SystemPreloadNew",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "lastTime",
                    "id": 1
                }
            ]
        },
        {
            "name": "Response",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "lastTime",
                    "id": 1
                },
                {
                    "rule": "repeated",
                    "type": "TargetLanguage",
                    "name": "targetLanguages",
                    "id": 2
                },
                {
                    "rule": "repeated",
                    "type": "AcceptAgreement",
                    "name": "acceptAgreement",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "flagOpen",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "mobilePhoneBind",
                    "id": 5
                },
                {
                    "rule": "repeated",
                    "type": "VCertificationInfo",
                    "name": "vCertificationInfos",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "auditSwitchSignTemp",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "vpFlag",
                    "id": 8
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "mallkgFlag",
                    "id": 9
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "shumeiPopupRate",
                    "id": 10
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "serverTime",
                    "id": 11
                },
                {
                    "rule": "repeated",
                    "type": "SourceRefuse",
                    "name": "sourceRefuses",
                    "id": 12
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "attVersion",
                    "id": 13
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "forceBindWitch",
                    "id": 14
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "privacyProtocolSwitch",
                    "id": 15
                },
                {
                    "rule": "optional",
                    "type": "CollectReportCycle",
                    "name": "crc",
                    "id": 16
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "iosJailbreakSwitch",
                    "id": 17
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "apiEncryFlag",
                    "id": 18
                }
            ]
        },
        {
            "name": "AcceptAgreement",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "country",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "value",
                    "id": 2
                }
            ]
        },
        {
            "name": "TargetLanguage",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "language",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "content",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "description",
                    "id": 3
                }
            ]
        },
        {
            "name": "VCertificationInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "no",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "icon",
                    "id": 2
                }
            ]
        },
        {
            "name": "SourceRefuse",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "bindType",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "switch",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "warningSwitch",
                    "id": 3
                }
            ]
        },
        {
            "name": "CollectReportCycle",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "interval",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "bodySize",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "clientPointInterval",
                    "id": 3
                }
            ]
        }
    ]
}).build();
export default _root;



// WEBPACK FOOTER //
// ./js/pb_map/protos_file/SystemPreloadNew.pb.js